function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanoLogoPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152.18 25.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7,13.16a8.42,8.42,0,0,1-16.69,0H24.52a13.89,13.89,0,0,0,27.67,0Z",
    style: {
      fill: "#00a8e1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.31 7.9 6.02 7.9 6.02 0 0 0 0 24.76 6.02 24.76 6.02 13.16 16.31 13.16 16.31 24.76 22.29 24.76 22.29 0 16.31 0 16.31 7.9",
    style: {
      fill: "#00a8e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.16,6C136.63,6,132,9.88,132,15.63s4.59,9.65,10.12,9.65,10-3.86,10-9.65S147.59,6,142.16,6Zm0,14.34a4.54,4.54,0,0,1-4.51-4.73,4.47,4.47,0,1,1,8.92,0A4.52,4.52,0,0,1,142.16,20.36Z",
    style: {
      fill: "#00a8e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.69,6c-2.71,0-4.23.54-5.61,2h-4.9V24.77H117V16.28c0-3.52,1.49-5.09,3.78-5.09,1.86,0,3.13,1.46,3.13,3.6v10h5.79V13.56C129.71,9,126.14,6,121.69,6Z",
    style: {
      fill: "#00a8e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.92,6c-5.42,0-9.46,3.93-9.46,9.68s4.08,9.69,8.92,9.69a8.2,8.2,0,0,0,5.68-2v1.46h5.83V8h-4.54A9.84,9.84,0,0,0,96.92,6Zm.66,14.41c-2.54,0-4.4-1.89-4.4-4.73a4.4,4.4,0,0,1,4.4-4.73,4.56,4.56,0,0,1,4.48,4.73A4.53,4.53,0,0,1,97.58,20.36Z",
    style: {
      fill: "#00a8e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,6A8.21,8.21,0,0,0,70.86,9a6.79,6.79,0,0,0-6-3.09c-2.37,0-4.44.62-5.68,2H54.32V24.77h5.82v-9c0-3.05,1.38-4.62,3.5-4.62a3.11,3.11,0,0,1,3.09,3.39V24.77h5.83v-9c0-3.05,1.42-4.62,3.56-4.62a3.1,3.1,0,0,1,3.06,3.39V24.77H85V13.34A7.33,7.33,0,0,0,77.51,6Z",
    style: {
      fill: "#00a8e1"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanoLogoPrimary);
export default __webpack_public_path__ + "static/media/humano_logo_primary.beee52d936fca863b7089c15d47f10d3.svg";
export { ForwardRef as ReactComponent };